import track from 'react-tracking';
import { Modal } from '@simplywallst/ui-core';
import { Button } from '@simplywallst/ui-core';
import { SWS_HOST } from '@/constants';

export interface SharePortfolioModalProps {
  portfolioId: string;
  portfolioName: string;
  secretCode: string;
  onClose: () => void;
  onConfirm: () => void;
}

const SharePortfolioModal = ({
  onClose,
  onConfirm,
  portfolioId,
  secretCode,
}: SharePortfolioModalProps) => {
  const url = `${SWS_HOST}/portfolio/shared-portfolios/${portfolioId}/${secretCode}`;
  return (
    <Modal
      title="Share Portfolio"
      onSecondaryClick={onClose}
      onPrimaryClick={onConfirm}
      primaryLabel="Done"
    >
      <p>
        <strong>Your sharing url is: </strong>
        <Button as="a" styleType="strongLink" href={url}>
          {url}
        </Button>
      </p>
    </Modal>
  );
};

export default track({
  type: 'track',
  subject: 'SharePortfolioModal',
})(SharePortfolioModal) as typeof SharePortfolioModal;
